import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.common.requestSelectors.QBooks', {
    lockDateOverrideWarning:
        'When approved, the date will change to {newDate} because the lock date is set for {lockDate}',
    matchingPolicyViolationNotMatchedToAnyPurchaseOrder:
        "Bill can't be approved since it is not matched to any Purchase Order.",
    matchingPolicyViolationMatchedNotAllItems: "Bill can't be approved since not all items are matched.",
});
